import React from 'react';
import { useI18n } from '../i18n/I18nContext';

const SupportLanguageNotice = ({ compact = false }) => {
  const { t } = useI18n();

  return (
    <aside
      className={`support-language-notice${compact ? ' support-language-notice--compact' : ''}`}
      aria-label={t('support.englishOnlyTitle')}
    >
      <span aria-hidden="true">EN</span>
      <div>
        <strong>{t('support.englishOnlyTitle')}</strong>
        <p>{compact ? t('support.englishOnly') : t('support.englishOnlyDescription')}</p>
      </div>
    </aside>
  );
};

export default SupportLanguageNotice;
